import React, { useEffect, useState } from 'react';
import { ReportDetail, Direction, ReduxState, Pagination, AnswerStatus } from 'interface';
import { connect, ConnectedProps } from 'react-redux';
import { OutlinedInput, Switch } from '@material-ui/core';
import './answerList.style.scss';
import AnswerCard from './card/answerCard.index';
import AnswerCardSkeleton from './card/answerCard.skeleton';
import { useHistory, useParams } from 'react-router';
import { userFormDataStatus, WSData } from 'scripts/storage';
import { withStyles, Theme, createStyles } from '@material-ui/core/styles';
import { API, RoutePath } from 'data';
import { get, post } from 'scripts/api';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';
import PaginationComp from 'utilities/components/pagination/pagination.index';
import useInterval from 'scripts/useInterval';
import { setExpire, setUserData } from 'redux/actions';

const FormAnswerList: React.FC<ConnectedProps<typeof connector>> = function (props: ConnectedProps<typeof connector>) {
    const lang = props.lang.wsPanel.answerList;
    const { form } = useParams<any>();
    const [answers, setAnswers] = useState<Pagination<ReportDetail>>();
    const history = useHistory();
    const formTitle = WSData.getForm(form)?.title;
    const [loading, setLoading] = useState(false);
    const [notification, setNotification] = useState(WSData.getForm(form)?.want_answer_notif);
    const dataStorage = WSData.get();
    const [activePage, setActivePage] = useState(1);
    const answerCountShow = 20;
    // const [searchTitle, setSearchTitle] = useState('');
    const [refreshing, setRefreshing] = useState(false);

    let wsId: number | undefined = undefined;
    props.workspaces?.map((i) =>
        i.forms.map((j) => {
            if (j.id === Number(form)) wsId = i.id;
        }),
    );
    const AntSwitch = withStyles((theme: Theme) =>
        createStyles({
            root: {
                width: 24,
                height: 14,
                padding: 0,
                display: 'flex',
            },
            switchBase: {
                padding: 2,
                color: theme.palette.grey[500],
                '&$checked': {
                    transform: 'translateX(10px)',
                    color: theme.palette.common.white,
                    '& + $track': {
                        opacity: 1,
                        backgroundColor: '#1dd0d6',
                        borderColor: '#1dd0d6',
                    },
                },
            },
            thumb: {
                width: 10,
                height: 10,
                boxShadow: 'none',
            },
            track: {
                border: `1px solid ${theme.palette.grey[500]}`,
                borderRadius: 16 / 2,
                opacity: 1,
                backgroundColor: theme.palette.common.white,
            },
            checked: {},
        }),
    )(Switch);

    const getData = () => {
        get<Pagination<ReportDetail>>(API.report(form), {
            page_size: answerCountShow,
            page: activePage,
            state: AnswerStatus.complete,
        })
            .then((res) => {
                if (wsId) {
                    setAnswers(res.data);
                }
            })
            .catch((res) => {
                if (res.status >= 500) toast.error(props.lang.serverErr);
                else if (res.status >= 400) {
                    if (res.status === 401) props.dispatch(setExpire(true));
                } else if (refreshing) toast.error(lang.refreshNoInternetErr);
            })
            .finally(() => setRefreshing(false));
    };

    useInterval(() => {
        if (activePage === 1) getData();
    }, 3 * 60 * 1000);

    useEffect(() => {
        if (dataStorage) {
            dataStorage.map((i) => {
                i.forms.map((j) => {
                    if (j.id === Number(form) && notification !== undefined) {
                        j.want_answer_notif = notification;
                    }
                });
            });
            WSData.set([...dataStorage]);
        }
    }, [notification]);

    // useEffect(() => {
    //     let newList: ReportDetail[] | undefined;
    //     if (searchTitle !== '') {
    //         newList = allAnswers?.filter((item) => {
    //             const name = item.id.toString().toLowerCase();
    //             const filter = searchTitle.toLowerCase();
    //             return name.includes(filter);
    //         });
    //         setAnswers(newList);
    //     } else setAnswers(allAnswers);
    // }, [searchTitle, allAnswers]);

    useEffect(() => {
        setAnswers(undefined);
        getData();
    }, [activePage]);

    const refresh = () => {
        if (props.expire) {
            toast.error(
                'کاربر محترم به منظور فعالسازی مجدد قابلیت بارگزاری پاسخنامه ها لطفا یک بار از حساب کاربری خود خارج و مجددا وارد شوید',
            );
        } else {
            setRefreshing(true);
            if (activePage === 1) getData();
            else setActivePage(1);
        }
    };

    const setFav = () => {
        post<{ result: 'added' | 'removed' }>(API.dashboard.profile.setFavForm, { form: Number(form) })
            .then((res) => {
                const newUserData = props.user;
                if (newUserData) {
                    if (res.data.result === 'added' && !newUserData.favorite_forms.includes(Number(form))) {
                        newUserData.favorite_forms.push(Number(form));
                    } else if (res.data.result === 'removed' && newUserData.favorite_forms.includes(Number(form))) {
                        newUserData.favorite_forms = newUserData.favorite_forms.filter((i) => i !== Number(form));
                    }
                    props.dispatch(setUserData({ ...newUserData }));
                }
            })
            .catch((res) => {
                if (res.status >= 500) toast.error(props.lang.serverErr);
                else if (res.status >= 400) toast.error(lang.errorFav);
                else toast.error(props.lang.unknownErr);
            });
    };

    return (
        <div className="kiosk-form-answer-sheet">
            <div className="header-answer-list d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center page-title">
                    <i onClick={() => history.push(RoutePath.dashboard.index)} className="material-icons-outlined">
                        east
                    </i>
                    <h3>{formTitle}</h3>
                </div>
                <div className="d-flex align-items-center icons">
                    <i onClick={refresh} className={`material-icons-outlined ${refreshing ? 'rotate' : ''}`}>
                        {refreshing ? 'sync' : 'refresh'}
                    </i>
                    <i
                        className={`favorite material-icons${
                            props.user?.favorite_forms.includes(Number(form)) ? '' : '-outlined'
                        }`}
                        onClick={setFav}
                    >
                        grade
                    </i>
                </div>
            </div>
            <div className="notification-container">
                <div className="d-flex align-items-center justify-content-between mb-1">
                    <div className="text d-flex align-items-center">
                        <i className="material-icons notification-icon">notifications</i>
                        <span>{lang.notification}</span>
                    </div>
                    {!loading ? (
                        <AntSwitch
                            checked={notification}
                            onChange={() => {
                                setLoading(true);
                                post(API.form.setFormNotif(form), {})
                                    .then(() => setNotification(!notification))
                                    .catch((res) => {
                                        if (res.status >= 500) toast.error(props.lang.serverErr);
                                        else if (res.status >= 400) toast.error(lang.errNotif);
                                        else toast.error(lang.noInternetErr);
                                    })
                                    .finally(() => setLoading(false));
                            }}
                        />
                    ) : (
                        <Spinner animation="border" />
                    )}
                </div>
                <div className="text-desc">{lang.notificationDesc}</div>
            </div>
            {props.expire ? (
                <p className="expire-error">
                    کاربر محترم به منظور فعالسازی مجدد بروزرسانی پاسخ نامه های ثبت شده لطفا یک بار از حساب کاربری خود
                    خارج و مجددا وارد شوید.
                </p>
            ) : null}
            {/* <div className="search">
                <OutlinedInput
                    placeholder={lang.searchBoxPH}
                    className="search-box"
                    dir={Direction.rtl}
                    onChange={(e) => setSearchTitle(e.target.value)}
                    endAdornment={<i className="material-icons">search</i>}
                    value={searchTitle}
                />
            </div> */}
            <div className="contents">
                {answers ? (
                    answers.count ? (
                        <>
                            {answers.data.map((item, index) => (
                                <AnswerCard data={item} key={index} />
                            ))}
                            {answers.num_of_pages > 1 ? (
                                <PaginationComp
                                    onPageChange={(e) => setActivePage(e)}
                                    totalPages={answers.num_of_pages}
                                    activePage={activePage}
                                />
                            ) : null}
                        </>
                    ) : (
                        <p>{lang.noAnswer}</p>
                    )
                ) : (
                    <>
                        {Array.from(Array(10).keys()).map((item, index) => (
                            <AnswerCardSkeleton key={index} />
                        ))}
                    </>
                )}
                <div className="my-grid" />
                <div className="my-grid" />
                <div className="my-grid" />
            </div>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    user: state.userData,
    lang: state.lang,
    expire: state.expired,
    workspaces: state.workspacesData,
});

const connector = connect(mapStateToProps);
export default connector(FormAnswerList);
